export const offerList = [
    {
        iconClass: "fa-solid fa-laptop-code",
        title: "Strony internetowe",
        description: "Oparte na najnowszych standardach. Podejście 'mobile first' gwarantuje doskonałą widoczność na wszystkich urządzeniach. Klient może być pewien, że jego strona będzie zgodna z najnowszymi trendami i dostosowana do różnych urządzeń.",
    },

    {
        iconClass: "fa-solid fa-server",
        title: "Rozwiązania hostingowe",
        description: "Kompleksowe usługi hoistingowe. Doradctwo w wyborze, rejestracji domenty i hoistingu. Implementacja protokołu SSL. Umieszczenie treści na serwerze.",
    },
    {
        iconClass: "fa-solid fa-arrow-up-right-dots",
        title: "Optymalizacja SEO",
        description: "Tworzenie stron www przyjaznych wyszukiwarkom. Stosowanie najnowszych standardów, odpowiednich znaczników semantycznych. Wybór odpowiednich słów kluczowych. Optymalizacja szybkości strony.",
    },
    {
        iconClass: "fa-solid fa-screwdriver-wrench",
        title: "Administracja strony",
        description: "Kontrola nad prawidłowym działaniem strony internetowej. Wprowadzanie niezbędnych poprawek. Modernizacja teści. Aktualizowanie wtyczek CMS.",
    },
    {
        iconClass: "fa-solid fa-photo-film",
        title: "Web Design",
        description: "Tworzenie mockupów stron www na podstawie najnowszych standardów UX/UI.  Projektowanie loga, grafik",
    }
];